export default "__VITE_ASSET__CwSWxyvC__"